/**
 * Repaints a collection's count after it has been saved, without reloading the page.
 *
 * The save happens inside a React modal; the count lives in Razor markup outside every React root
 * on the page. Rather than give React a handle on foreign DOM, the modal announces what happened
 * and this listens — the same one-way arrangement `js/modules/likeCollection.js` has with its own
 * button, and the reason a save can update a card the modal knows nothing about.
 *
 * The server sends the count back already formatted (`FormatLikeCount()`), so nothing here has to
 * know how "1.5K" is spelled.
 */

const SAVED_EVENT = "valspar:collection-saved";

function updateCard(menu, likesCount) {
  const card = menu.parentElement;
  if (!card) return;

  const existing = card.querySelector(".colour-collections__slide-likes");

  if (existing) {
    // The icon is a sibling of the text node, so replace only the last child rather than the
    // element's whole contents.
    existing.lastChild.textContent = ` ${likesCount}`;
    return;
  }

  // A collection with no saves or likes yet renders no count element at all, so the first save has
  // nothing to update. Nothing is inserted here on purpose: building the markup a second time in
  // JavaScript is how the two copies drift. The count appears on the next page load.
}

function updateDetailPage(likesCount) {
  const count = document.querySelector(".js-collection-like-button .like-count");
  if (count) {
    count.textContent = likesCount;
  }
}

export function initCollectionSaveCount() {
  window.addEventListener(SAVED_EVENT, (event) => {
    const { collectionId, likesCount } = event.detail ?? {};
    if (!collectionId || !likesCount) return;

    document
      .querySelectorAll(`.react-collection-card-menu[data-collection-id="${collectionId}"]`)
      .forEach((menu) => updateCard(menu, likesCount));

    updateDetailPage(likesCount);
  });
}
